import { GetAllReportProvvedimentiFiltersDTO, GetAllReportProvvedimentiResponseData } from "./dto";
import {ReportProvvedimentiImpl } from "./serviceImpl";

export interface ReportProvvedimentiService {
    GetAllReportProvvedimenti(filters: GetAllReportProvvedimentiFiltersDTO): Promise<GetAllReportProvvedimentiResponseData[]>
}

export function NewReportProvvedimentiService(): ReportProvvedimentiService {
    return new ReportProvvedimentiImpl()
}